import React, { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { portfolio } from "../mock";

export default function Portfolio() {
  const [active, setActive] = useState(0);

  return (
    <section id="portfolio" className="py-28 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <div className="text-xs tracking-[0.32em] text-emerald-400 uppercase mb-4">04 — Portfolio</div>
            <h2 className="gt-serif text-4xl md:text-6xl leading-[1.02] max-w-3xl">
              Programs that <span className="text-emerald-400">ship revenue</span>, not certificates.
            </h2>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-7">
            <div className="relative rounded-3xl overflow-hidden gt-hairline aspect-[16/11]">
              <img
                key={portfolio[active].image}
                src={portfolio[active].image}
                alt={portfolio[active].title}
                className="w-full h-full object-cover transition-opacity duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="text-xs tracking-[0.3em] text-emerald-400 uppercase">
                  {String(active + 1).padStart(2, "0")} / {String(portfolio.length).padStart(2, "0")}
                </div>
                <h3 className="gt-serif text-4xl md:text-5xl text-white mt-2">{portfolio[active].title}</h3>
                <p className="text-neutral-300 mt-1">{portfolio[active].subtitle}</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-3">
            {portfolio.map((p, i) => (
              <button
                key={p.title}
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className={`group text-left p-5 rounded-2xl gt-hairline transition-all ${
                  active === i
                    ? "bg-emerald-400/10 border-emerald-400/40"
                    : "bg-white/[0.02] hover:bg-white/[0.04]"
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-xs text-neutral-500 mb-1">0{i + 1}</div>
                    <div className="gt-serif text-2xl text-white">{p.title}</div>
                    <div className="text-sm text-neutral-400 mt-1">{p.subtitle}</div>
                  </div>
                  <ArrowUpRight
                    className={`w-5 h-5 transition-all ${
                      active === i ? "text-emerald-400" : "text-neutral-500 group-hover:text-white"
                    }`}
                  />
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
